import {
  EventPreparationTeamDetail,
  EventPreparationTeamDetailsSportFactory,
} from './types'

export function eventPreparationTeamDetailsHandballFactory(): EventPreparationTeamDetailsSportFactory {
  function getDetails(): EventPreparationTeamDetail {
    return {
      buttons: {
        lineups: {
          name: 'Lineups',
          icon: 'users',
        },
        skins: {
          name: 'Skins',
          icon: 'tshirt',
        },
      },
      hasLineupsSelect: {
        show: true,
        name: 'Has lineups',
      },
    }
  }

  return { getDetails }
}
